import { ChevronLeft, ChevronRight } from "lucide-react";

export default function VideoModal({
    video,
    index,
    total,
    onClose,
    onNext,
    onPrev,
}) {
    return (
        <div className="video-modal" onClick={onClose}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                <video src={video.media} autoPlay controls className="modal-video" />

                <button className="close-btn-vd" onClick={onClose}>✕</button>

                {index > 0 && (
                    <button className="prev-btn" onClick={onPrev}>
                        <ChevronLeft />
                    </button>
                )}

                {index < total - 1 && (
                    <button className="next-btn" onClick={onNext}>
                        <ChevronRight />
                    </button>
                )}
            </div>
        </div>
    );
}
